import { setCookie } from './_cookie';

export function trigger() {
  function reset() {
    document.documentElement.classList.remove('is-nav-active', 'is-search-active', 'is-modal-active', 'is-cart-added');
  }
  
  const triggerNav = document.querySelector('.trigger-nav');
  if(triggerNav) {
    triggerNav.addEventListener('click', function(e) {
      e.preventDefault();
      if(document.documentElement.classList.contains('is-nav-active')){
        reset();
        document.documentElement.classList.add('is-chat-playing');
      } else {
        reset();
        document.documentElement.classList.add('is-nav-active');
        document.documentElement.classList.remove('is-chat-playing');
      }
    });
  }

  const triggerHomeState = document.querySelector('.trigger-home-state');
  if(triggerHomeState) {
    triggerHomeState.addEventListener('click', function(e) {
      e.preventDefault();
      if(document.documentElement.classList.contains('is-home-index-active')){
        setCookie('mittan-homeMode', '');
        document.documentElement.classList.remove('is-home-index-active');
        document.documentElement.classList.add('is-chat-playing');
      } else {
        setCookie('mittan-homeMode', '1');
        document.documentElement.classList.add('is-home-index-active');
        document.documentElement.classList.remove('is-chat-playing');
      }
    });
  }

  const triggerArchivetags = document.querySelector('.trigger-archive-tags');
  if(triggerArchivetags) {
    triggerArchivetags.addEventListener('click', function(e) {
      e.preventDefault();
      if(document.documentElement.classList.contains('is-archive-tags-active')){
        document.documentElement.classList.remove('is-archive-tags-active');
      } else {
        document.documentElement.classList.add('is-archive-tags-active');
      }
    });
  }

  const triggerProductCategories = document.querySelector('.trigger-product-categories');
  if(triggerProductCategories) {
    triggerProductCategories.addEventListener('click', function(e) {
      e.preventDefault();
      if(document.documentElement.classList.contains('is-product-categories-active')){
        document.documentElement.classList.remove('is-product-categories-active');
      } else {
        document.documentElement.classList.add('is-product-categories-active');
      }
    });
  }

  const triggerSearch = document.querySelectorAll('.trigger-search');
  const inputSearch = document.querySelector('.input-search');
  if(triggerSearch.length) {
    triggerSearch.forEach((el, index) => {
      el.addEventListener('click', function(e) {
        e.preventDefault();
        if(document.documentElement.classList.contains('is-search-active')){
          reset();
          if(inputSearch) inputSearch.blur();
        } else {
          reset();
          document.documentElement.classList.add('is-search-active');
          if(inputSearch) inputSearch.focus();
        }
      });
    });
  }

  const triggerReset = document.querySelectorAll('.trigger-reset');
  if(triggerReset.length) {
    for (let i = 0; i < triggerReset.length; i++) {
      const el = triggerReset[i];
      el.addEventListener('click', function(e) {
        e.preventDefault();
        reset();
      });
    }
  }
}
